import Select from 'react-select';
import { ReactSelectStyle } from "../Style/ReactSelect";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isUnderLegalAge } from "../Utils/AgeVerification";

function BrowserDatePicker({ formData, setFormData, errors, setErrors, dayOfBirthRef, monthOfBirthRef, setIsUnderage }) {
    const { i18n } = useTranslation();
    const daysInMonth = (month, year) => {
        const rules = [31, !year || isLeap(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        return rules[month - 1];
    };
    const isLeap = year => new Date(year, 1, 29).getDate() === 29;
    const evaluateAge = (day, month, year) => {
        if (day?.id && month?.id && year?.id) {
            setIsUnderage(isUnderLegalAge(day.id, month.id, year.id, formData.country?.id));
        } else {
            setIsUnderage(false);
        }
    }
    const onDayOfBirthChange = (dayOfBirthOption) => {
        if (dayOfBirthOption) {
            const monthOfBirth = dayOfBirthOption?.id > daysInMonth(formData.monthOfBirth?.id, formData.yearOfBirth?.id) ? '' : formData.monthOfBirth;
            if (monthOfBirth === '') {
                setFormData(prev => ({ ...prev, monthOfBirth: '' }));
            }
            setErrors(prev => ({ ...prev, dayOfBirth: undefined }));
            setFormData(prev => ({ ...prev, dayOfBirth: dayOfBirthOption }));
            evaluateAge(dayOfBirthOption, monthOfBirth, formData.yearOfBirth);
        }
        else {
            setFormData(prev => ({ ...prev, dayOfBirth: undefined }));
            evaluateAge(undefined, formData.monthOfBirth, formData.yearOfBirth);
        }
    }
    const onMonthOfBirthChange = (monthOfBirthOption) => {
        if (monthOfBirthOption) {
            const dayOfBirth = formData.dayOfBirth?.id > daysInMonth(monthOfBirthOption.id, formData.yearOfBirth?.id) ? '' : formData.dayOfBirth;
            if (dayOfBirth === '') {
                setFormData(prev => ({ ...prev, dayOfBirth: '' }));
            }
            setErrors(prev => ({ ...prev, monthOfBirth: undefined }));
            setFormData(prev => ({ ...prev, monthOfBirth: monthOfBirthOption }));
            evaluateAge(dayOfBirth, monthOfBirthOption, formData.yearOfBirth);
        }
        else {
            setFormData(prev => ({ ...prev, monthOfBirth: undefined }));
            evaluateAge(formData.dayOfBirth, undefined, formData.yearOfBirth);
        }
    }
    const onYearOfBirthChange = (yearOfBirthOption) => {
        if (yearOfBirthOption) {
            const dayOfBirth = formData.dayOfBirth?.id > daysInMonth(formData.monthOfBirth?.id, yearOfBirthOption.id) ? '' : formData.dayOfBirth;
            if (dayOfBirth === '') {
                setFormData(prev => ({ ...prev, dayOfBirth: '' }));
            }
            setFormData(prev => ({ ...prev, yearOfBirth: yearOfBirthOption }));
            evaluateAge(dayOfBirth, formData.monthOfBirth, yearOfBirthOption);
        }
        else {
            setFormData(prev => ({ ...prev, yearOfBirth: undefined }));
            evaluateAge(formData.dayOfBirth, formData.monthOfBirth, undefined);
        }
    }
    var years = Array.from({ length: (new Date().getFullYear() - 1900) }, (v, k) => ({ id: 1900 + k + 1, name: 1900 + k + 1 })).reverse();
    var months = Array.from({ length: 12 }, (v, k) => ({ id: k + 1, name: k + 1 }));
    var days = Array.from({ length: 31 }, (v, k) => ({ id: k + 1, name: k + 1 }));

    return (
        <>
            <div className="m-2 text-nowrap" style={{ flex: 1 }}>
                <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="day">{`* ${i18n.t("day")}`}</label>
                <Select isClearable={true} id="day" placeholder="" onChange={onDayOfBirthChange} ref={dayOfBirthRef} value={formData.dayOfBirth} getOptionLabel={(o) => o.name} getOptionValue={(o) => o.id} styles={ReactSelectStyle} options={days} className={`${errors.dayOfBirth ? "is-invalid" : ""}`} />
                <div className="invalid-feedback">{i18n.t('required')}</div>
            </div>
            <div className="m-2 text-nowrap" style={{ flex: 1 }}>
                <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="month">{`* ${i18n.t("month")}`}</label>
                <Select isClearable={true} id="month" placeholder="" onChange={onMonthOfBirthChange} ref={monthOfBirthRef} value={formData.monthOfBirth} getOptionLabel={(o) => o.name} getOptionValue={(o) => o.id} styles={ReactSelectStyle} options={months} className={`${errors.monthOfBirth ? "is-invalid" : ""}`} />
                <div className="invalid-feedback">{i18n.t('required')}</div>
            </div>
            <div className="m-2 text-nowrap" style={{ flex: 1 }}>
                <label style={{ color: '#5B5A57', fontSize: 'smaller' }} for="year">{i18n.t("year")}</label>
                <Select isClearable={true} id="year" placeholder="" onChange={onYearOfBirthChange} value={formData.yearOfBirth} getOptionLabel={(o) => o.name} getOptionValue={(o) => o.id} styles={ReactSelectStyle} options={years} />
            </div>
        </>
    );
}
export default BrowserDatePicker;